module.exports=function(scope){ return `<div id="${scope.id}" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label ${scope.cls}">
    <textarea id="${scope.id}-input" class="mdl-textfield__input" type="text" rows="${scope.rows}" value="${scope.value}" ${scope.readonly} ${scope.required}></textarea>
    <label class="mdl-textfield__label" for="${scope.id}-input">${scope.label}</label>
    <span class="mdl-textfield__error">${scope.error}</span>
</div>`};